<template>
  <CustomTable
    :title="`Параметры: ${frameRow?.frame_name || ''}`"
    :rowsData="data"
    :columns="columns"
    :loading="isLoading"
    :custom-body="true"
    :sticky-header="true"
    class="params-table-component"
  >
    <template #top-right>
      <div class="header-actions">
        <q-btn
          v-if="hasAnyChanges()"
          label="Сохранить"
          color="primary"
          @click="this.handleSaveClick"
          class="action-btn"
          icon="save"
          size="sm"
        />
        <q-btn
          v-if="hasAnyChanges()"
          label="Отменить изменения"
          color="orange"
          @click="this.resetChanges"
          class="action-btn ml-2"
          icon="loop"
          size="sm"
        />
      </div>
    </template>
    <template #customBody="props">
      <q-tr>
        <custom-table-cell align="center">
          {{ props.row.frame_param_id }}
        </custom-table-cell>
        <custom-table-cell align="left">
          {{ props.row.frame_param_type_name }}
        </custom-table-cell>
        <custom-table-cell align="center">
            <CustomInput
              type="number" :controls="true" :autoMinWidth="true" :showClearIcon="false"
              :value="formData[props.row.frame_param_type_id] || props.row.param_value"
              :style="`background-color: ${hasAnyChanges(props.rowIndex) ? '#d0ffc3' : 'unset'};`"
              @change_input="(value) => handleInputChange(props.row.frame_param_type_id, value)"
            />
        </custom-table-cell>
      </q-tr>
    </template>
  </CustomTable>
</template>

<script>
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";

import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import CustomIcon from "@/components/common/CustomIcon";
import CheckOrClose from "@/components/common/CheckOrClose";
import CustomInput from "@/components/form/CustomInput";
import {
  updateFrameParams,
  deleteFrameParam,
  getFrameParams,
} from "@/views/Frames/List/services";
export default {
  name: "FrameParams",
  components: {
    CustomIcon,
    CustomTableCell,
    CustomTable,
    CheckOrClose,
    CustomInput,
  },
  props: {
    columns: {
      type: Array,
      required: true,
    },
    frameRow: {
      type: Object,
      required: true,
    },
    resetState: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      deleteLoading: {},
      data: [],
      isLoading: false,
      editingRows: this.resetState || {},
      formData: {},
    };
  },
  mounted() {
    this.getParams();
  },
  watch: {
    frameRow: {
      handler() {
        this.getParams();
      },
      immediate: true,
    },
  },
  methods: {
    async getParams() {
      this.isLoading = true;
      const res = await getFrameParams(this.frameRow.frame_id);
      this.isLoading = false;
      if (!res) return;
      this.data = res;
    },
    async handleSaveClick() {
      if (Object.keys(this.formData).length === 0) {
        this.showSucceedSnackbar();
        return;
      }
      
      const updatedParams = [];
      
      for (const frameParamId in this.formData) {
        const row = this.data.find(item => item.frame_param_type_id === parseInt(frameParamId));
        updatedParams.push({
          frame_id: this.frameRow.frame_id,
          frame_param_type_id: parseInt(frameParamId),
          frame_param_id: row ? row.frame_param_id : null,
          param_value: this.formData[frameParamId]
        });
      }
      // Проверка всех значений param_value с учетом изменений в formData
        const hasEmptyValues = this.data.some(item => {
          const currentValue = this.formData[item.frame_param_type_id] !== undefined ? 
            this.formData[item.frame_param_type_id] : item.param_value;
          return currentValue === null || currentValue === undefined || currentValue === '';
        });

      if (hasEmptyValues) {
        this.showErrorSnackbar('Заполните все поля со значением');
        return;
      }

      if (updatedParams.length > 0) {
        await this.onUpdateSubmit({ data: updatedParams });
      }
      
      // Сбрасываем режим редактирования
      this.editingRows = {};
      this.formData = {};
    },
    async onUpdateSubmit(body) {
      const res = await updateFrameParams(body);
      if (!res) return;      
      this.data = res;
      this.showSucceedSnackbar();
    },
    async onDeleteSubmit(frame_param_id) {
      if (this.deleteLoading[frame_param_id]) return;
      this.deleteLoading = { ...this.deleteLoading, [frame_param_id]: true };
      const res = await deleteFrameParam(frame_param_id);
      this.deleteLoading = { ...this.deleteLoading, [frame_param_id]: false };
      if (!res) return;
      this.showSucceedSnackbar();
      this.data = this.data.filter(
        (row) => row.frame_param_id !== frame_param_id
      );
    },
    
    handleInputChange(frameParamId, value) {
      this.formData = {
        ...this.formData,
        [frameParamId]: value
      };
    },
    
    hasAnyChanges(rowIndex, parentMode = false) {
      // Если проверяем все изменения
      if (rowIndex === undefined) {
        return Object.keys(this.formData).length > 0;
      }
      
      // Если проверяем конкретную строку
      const row = this.data[rowIndex];
      if (!row) return false;
      
      const frameParamId = row.frame_param_type_id;
      return this.formData[frameParamId] !== undefined && 
             this.formData[frameParamId] !== row.param_value;
    },
    
    resetChanges() {
      this.formData = {};
      this.editingRows = {};
      this.showSucceedSnackbar("Изменения отменены");
    },
  },
  setup() {
    const { showSucceedSnackbar, showErrorSnackbar } = useCustomSnackbar();
    return { showSucceedSnackbar, showErrorSnackbar };
  },
};
</script>

<style>
.ml-2 {
  margin-left: 8px;
}
</style>
